import { axiosInstance as instance } from './axiosInstance';
import { Account } from './dataTypes';

export type GetAccountResponse = Account;

export function getAccount() {
  return instance.get<GetAccountResponse>('/accounts/me');
}
